module.exports = __webpack_public_path__ + "img/blog_provisional.8fa97a4d.png";